import { PhoneNumber } from '@ngsos/portal-core/incidents';

const PHONE_CANDIDATE = /\+?\d[\d\-().]{5,}\d/g;

const JWT = /\beyJ[A-Za-z0-9_-]{4,}\.[A-Za-z0-9_-]+(?:\.[A-Za-z0-9_-]*)?/g;

const SENSITIVE_URL_PARAMETERS = new Set([
  'access_token',
  'code',
  'id_token',
  'phone',
  'phonenumber',
  'refresh_token',
  'session_state',
  'state',
  'token',
]);

const REDACTED = '[redacted]';

function maskPhoneNumber(candidate: string): string {
  const phoneNumber = PhoneNumber.tryInitialize(candidate);
  if (phoneNumber === null) {
    return candidate;
  }

  const region = phoneNumber.getRegionCode();
  const lastDigits = phoneNumber.value.slice(-3);

  return region === '' ? `[phone ***${lastDigits}]` : `[phone ${region} ***${lastDigits}]`;
}

export function redactSensitiveText(text: string): string {
  return text.replace(JWT, '[redacted token]').replace(PHONE_CANDIDATE, maskPhoneNumber);
}

function redactSearchParameters(parameters: URLSearchParams): void {
  for (const key of [...parameters.keys()]) {
    if (SENSITIVE_URL_PARAMETERS.has(key.toLowerCase())) {
      parameters.set(key, REDACTED);
    }
  }
}

function hashCarriesCredentials(hash: string): boolean {
  const parameters = new URLSearchParams(hash.replace(/^#/, ''));
  return [...parameters.keys()].some((key) => SENSITIVE_URL_PARAMETERS.has(key.toLowerCase()));
}

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

export function redactUrl(rawUrl: string): string {
  let url: URL;
  try {
    url = new URL(rawUrl);
  } catch {
    return redactSensitiveText(safeDecode(rawUrl));
  }

  redactSearchParameters(url.searchParams);
  if (url.hash !== '' && hashCarriesCredentials(url.hash)) {
    url.hash = REDACTED;
  }

  return redactSensitiveText(safeDecode(url.toString()));
}
